const layerPnj = [
  {
    type: "PnjSprite",
    args: {
      x: 105,
      y: 52.5,
      texture: "pnj",
      name: "pnj_Roger"
    }
  }
];
export default layerPnj;
